export const environment = {
    production: true,
    staging: false,
    version: "060220261619",
    hmr: false
};
